class PopinDialog extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector('dialog');
    this.closeButton = this.querySelector('[data-action="close"]');
    this.handle = `popin-seen-${this.dataset.handle}`;

    this.popinDialogs = document.querySelectorAll('popin-dialog');
  }

  connectedCallback() {
    if (!document.cookie.includes(this.handle)
      && !Shopify.designMode // Don't automatically open popin in shopify editor
    ) {
      this.openDialog();
    }

    this.closeButton.addEventListener('click', this.closeDialog.bind(this));
  }

  disconnectedCallback() {
    this.closeButton.removeEventListener('click', this.closeDialog.bind(this));
  }

  openDialog() {
    // Close all other dialogs
    this.popinDialogs.forEach((dialog) => {
      dialog.closeDialog();
    });

    // Open Dialog
    this.dialog.showModal();

    // Add listener on Escape key.
    document.addEventListener('keydown', this.onPressEscapeKey.bind(this));

    // Add listener on outside clicks.
    this.dialog.addEventListener('click', this.onClickOutside.bind(this));

    // Add 1 month cookie to prevent dialog from showing again.
    document.cookie = `${this.handle}=true; max-age=${60 * 60 * 24 * 30}; path=/`;
  }

  closeDialog() {
    // Close Dialog
    this.dialog.close();

    // Remove listener on Escape key.
    document.removeEventListener('keydown', this.onPressEscapeKey);

    // Remove listener on outside clicks.
    this.dialog.removeEventListener('click', this.onClickOutside);
  }

  onPressEscapeKey(event) {
    if (event.key === 'Escape') {
      this.closeDialog();
    }
  }

  onClickOutside(event) {
    if (event.target === this.dialog) {
      this.closeDialog();
    }
  }
}

customElements.define('popin-dialog', PopinDialog);